import React, { lazy, Suspense } from "react";
import "./App.css";

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import Footer from "./components/Footer";
import Scrollup from "./components/Scrollup";
import ScrollToTop from "./components/ScrollToTop";

// Lazy load non-critical routes
const WhyChoos = lazy(() => import("./components/WhyChoos"));
const Benner = lazy(() => import("./components/Benner"));
const Products = lazy(() => import("./pages/products/Products"));
const About = lazy(() => import("./pages/About"));
const Contact = lazy(() => import("./pages/Contact"));
const Gallery = lazy(() => import("./pages/Gallery"));
const CartPage = lazy(() => import("./pages/products/Card"));
const ShippingPolicy = lazy(() => import("./pages/policies/ShippingPolicy"));
const ReturnPolicy = lazy(() => import("./pages/policies/ReturnPolicy"));
const RefundPolicy = lazy(() => import("./pages/policies/RefundPolicy"));
const WarrantyPolicy = lazy(() => import("./pages/policies/WarrantyPolicy"));
const PrivacyPolicy = lazy(() => import("./pages/policies/PrivacyPolicy"));
const FAQ = lazy(() => import("./pages/others/Faqs"));
const TermsConditions = lazy(() => import("./pages/policies/TermsConditions"));
const ProductDetails = lazy(() => import("./pages/products/Productcard2"));
const Services = lazy(() => import("./pages/Services/Services"));
const Login = lazy(() => import("./pages/user/Login"));
const Logout = lazy(() => import("./pages/user/Logout"));
const Profile = lazy(() => import("./pages/user/Profile"));
const Registation = lazy(() => import("./pages/user/Registration"));
const Password = lazy(() => import("./pages/user/Password"));
const OtpVerify = lazy(() => import("./pages/user/OtpVerify"));
const Checkout = lazy(() => import("./pages/chekout/Checkout"));
const GatewayMyProfile = lazy(() => import("./pages/gateway/MyProfile"));
const GatewayMyOrder = lazy(() => import("./pages/gateway/MyOrder"));
const GatewayMyOrderDetails = lazy(() => import("./pages/gateway/MyorderDetails"));

const PageLoader = () => (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-white/80 backdrop-blur-sm">
    <div className="w-10 h-10 border-4 border-[#F36F21] border-t-transparent rounded-full animate-spin"></div>
  </div>
);

const App = () => {
  return (
    <Router>
      <ScrollToTop />
      <Navbar />

      <Suspense fallback={<PageLoader />}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/whychoose" element={<WhyChoos />} />
          <Route path="/benner" element={<Benner />} />
          <Route path="/products" element={<Products />} />
          <Route path="/about" element={<About />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/services" element={<Services />} />

          <Route path="/login" element={<Login />} />
          <Route path="/logout" element={<Logout />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/myprofile" element={<GatewayMyProfile />} />
          <Route path="/myorder" element={<GatewayMyOrder />} />
          <Route path="/myorderdetails/:id" element={<GatewayMyOrderDetails />} />
          <Route path="/registation" element={<Registation />} />
          <Route path="/password" element={<Password />} />
          <Route path="/verify-otp" element={<OtpVerify />} />

          <Route path="/cart" element={<CartPage />} />

          <Route path="/shipping-policy" element={<ShippingPolicy />} />
          <Route path="/return-policy" element={<ReturnPolicy />} />
          <Route path="/refund-policy" element={<RefundPolicy />} />
          <Route path="/refund-cancellation-policy" element={<RefundPolicy />} />
          <Route path="/warranty-policy" element={<WarrantyPolicy />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/products2/:id" element={<ProductDetails />} />
          <Route path="/terms-conditions" element={<TermsConditions />} />
          <Route path="/checkout" element={<Checkout />} />
        </Routes>
      </Suspense>

      <Footer />
      <Scrollup />
    </Router>
  );
};

export default App;
